import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue"
import PopupBase from "@/vue/common/popupBase.vue"

// Props
interface Props {
	overlayColor: string
	overlayMaxOpacity: number
	top?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DynamicPopup',
  props: {
    overlayColor: null,
    overlayMaxOpacity: null,
    top: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
	overlayColor: string
	overlayMaxOpacity: number
	top?: string
};



// Refs
const isPopupOpen = ref<boolean>(false)

function openPopup(): void {
	isPopupOpen.value = true
}

function closePopup(): void {
	isPopupOpen.value = false
}

// Exposing functions using defineExpose
expose({
	openPopup,
	closePopup,
})

return { __sfc: true,props, isPopupOpen, openPopup, closePopup, PopupBase }
}

})